var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"main-bg1"}),_c('h3',{staticClass:"error-title"},[_vm._v("找不到当前页面")]),_c('p',{staticClass:"error-main-tip"},[_vm._v(" 抱歉你访问的页面不存在。 ")])])
}]

export { render, staticRenderFns }